import { render, staticRenderFns } from "./ViewCorresponseDetails.vue?vue&type=template&id=882e5724&scoped=true&"
import script from "./ViewCorresponseDetails.vue?vue&type=script&lang=js&"
export * from "./ViewCorresponseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewCorresponseDetails.vue?vue&type=style&index=0&id=882e5724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882e5724",
  null
  
)

export default component.exports